import {uploadFile} from 'client/common/utils/api-client';

import config from 'client/common/utils/client-config';

import get from 'lodash/get';

import I18N from 'assets/i18n/brandlift-project';

const i18n = I18N.common.utils.imageUploader;

export interface ImageDimensions {
    width: number;
    height: number;
};

interface AvatarsPutRes {
    data: {
        url: string;
        dimensions: ImageDimensions;
        sizes: any;
    }
};

// eslint-disable-next-line max-statements
async function imageUploader(image: File, maxSize?: number) {
    const data = new FormData();
    const {name = '', size = 0} = image;
    const maxImageSize = maxSize ?? config.maxImageSize;

    if (size > maxImageSize * 1024 * 1024) {
        return {
            name,
            size,
            error: i18n.error.sizeGreater.replace('%s', maxImageSize.toString())
        };
    }

    data.append('file', image);

    try {
        const res: AvatarsPutRes = await uploadFile({file: data});
        const url: string = get(res, ['data', 'url']);
        const dimensions = get(res, ['data', 'dimensions']);
        const sizes = get(res, ['data', 'sizes']);

        return {
            url,
            size,
            name,
            dimensions,
            sizes
        };
    } catch (err) {
        return {
            name,
            size,
            error: i18n.error.default
        };
    }
}

export default imageUploader;
